// Central design tokens shared by the dashboard cards and the chart builders.
// Before this, the chart palette and status colours were duplicated per file.

import { MODULE_BY_KEY } from './dashboardModules';

// ---- Chart palette -------------------------------------------------------
const BASE_PALETTE = [
  '#6366F1', '#0EA5E9', '#22C55E', '#F59E0B', '#EC4899',
  '#14B8A6', '#8B5CF6', '#EF4444', '#84CC16', '#F97316',
  '#06B6D4', '#A855F7', '#EAB308', '#10B981', '#F43F5E',
];

// Extend with golden-angle hues so charts with many categories stay
// distinguishable well past the fixed palette.
const GOLDEN_ANGLE = 137.508;
const generatedPalette = Array.from({length: 40}, (_, i) => {
  const hue = Math.round((i + 1) * GOLDEN_ANGLE) % 360;
  return `hsl(${hue}, 62%, 54%)`;
});

export const CHART_PALETTE = [...BASE_PALETTE, ...generatedPalette];

// ---- Status tokens -------------------------------------------------------
// Keyed by a canonical status name (letters only, upper-case) so 'Pending',
// 'PARTIAL-COMPLETE' and 'Ref Follow' all resolve to the same token.
const canonicalStatus = (s) => String(s || '').toUpperCase().replace(/[^A-Z]/g, '');

export const STATUS_TOKENS = {
  PENDING: { hex: '#F59E0B', pillLight: 'bg-amber-100 text-amber-800', pillDark: 'bg-amber-900/40 text-amber-300' },
  COMPLETED: { hex: '#22C55E', pillLight: 'bg-green-100 text-green-800', pillDark: 'bg-green-900/40 text-green-300' },
  CANCELLED: { hex: '#EF4444', pillLight: 'bg-red-100 text-red-800', pillDark: 'bg-red-900/40 text-red-300' },
  PARTIALCOMPLETE: { hex: '#0EA5E9', pillLight: 'bg-blue-100 text-blue-800', pillDark: 'bg-blue-900/40 text-blue-300' },
  PARTIALLYCLOSED: { hex: '#8B5CF6', pillLight: 'bg-indigo-100 text-indigo-800', pillDark: 'bg-indigo-900/40 text-indigo-300' },
  REFFOLLOW: { hex: '#EC4899', pillLight: 'bg-purple-100 text-purple-800', pillDark: 'bg-purple-900/40 text-purple-300' },
  NEXTFOLLOWUP: { hex: '#8B5CF6', pillLight: 'bg-violet-100 text-violet-800', pillDark: 'bg-violet-900/40 text-violet-300' },
};

export const statusHex = (status) => STATUS_TOKENS[canonicalStatus(status)]?.hex;

export const statusPillClass = (status, isDark) => {
  const token = STATUS_TOKENS[canonicalStatus(status)];
  if (!token) return isDark ? 'bg-gray-700 text-gray-200' : 'bg-gray-100 text-gray-700';
  return isDark ? token.pillDark : token.pillLight;
};

// ---- Module accents ------------------------------------------------------
export const MODULE_COLORS = Object.fromEntries(
  Object.values(MODULE_BY_KEY).map((m) => [m.key, m.color]),
);
